import script from "./CoachConnector.vue?vue&type=script&setup=true&lang=js"
export * from "./CoachConnector.vue?vue&type=script&setup=true&lang=js"

import "./CoachConnector.vue?vue&type=style&index=0&id=1e977de7&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1e977de7"]])

export default __exports__